// Components==============
import Dropdown from 'components/UI/Dropdown/Dropdown';
import NoContent from 'components/UI/NoContent/NoContent';
import ProgressGraph from 'components/UI/ProgressGraph/ProgressGraph';
import { useRedux } from 'hooks/useRedux';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect, useState } from 'react';
import './Progress.module.scss';
// =========================

export default function Progress() {
  const themesWithProject = useThemesWithProject();
  const translate = useTranslate();
  const userId = useRedux((state) => state.authentication?.user?.id);

  const [selectedProject, setSelectedProject] = useState(
    themesWithProject[0]?.name || ''
  );

  const project = themesWithProject.find((t) => t?.name === selectedProject)
    ?.project;

  const processes = useRedux((state) =>
    project?.process?.map((id) => state.process?.entities.byId[id])
  )?.sort((a, b) => parseInt(a?.order || '0') - parseInt(b?.order || '0'));

  const endPointActivities =
    processes?.filter(
      (p) => p?.process_type !== 'App\\Phase' && p?.process_id !== 3
    ) || [];

  const graphData = useRedux((state) => {
    const reflections = state.reflection?.entities.allIds.map(
      (id) => state.reflection?.entities.byId[id]
    );

    return endPointActivities
      .map(
        (e) =>
          reflections?.find(
            (r) => r?.project_process_id === e?.id && r?.created_by === userId
          ) || 'filler'
      )
      .filter((e) => e);
  });

  const [saveKey, setSaveKey] = useState(0);
  useEffect(() => setSaveKey((prev) => prev + 1), [selectedProject]);

  return (
    <NoContent
      page="my-reflections"
      loading={false}
      hasContent={!!themesWithProject.length}
      decreasedHeight={70}
    >
      <div styleName="wrapper">
        <div styleName="selector ">
          <Dropdown
            initialOptions={themesWithProject.map((t) => t?.name || '')}
            initialText={selectedProject}
            selectedItem={selectedProject}
            setSelectedItem={setSelectedProject}
          />
        </div>
        <ProgressGraph
          data={graphData}
          topLeft={<strong>{translate('reflection.terms.progress')}:</strong>}
          project={project}
          saveKey={saveKey}
        />
      </div>
    </NoContent>
  );
}
